import { render, staticRenderFns } from "./PriceTimeline.vue?vue&type=template&id=85452a66"
import script from "./PriceTimeline.vue?vue&type=script&lang=js"
export * from "./PriceTimeline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports